var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn && _vm.hasRole('ui', 'UI_ENABLED_WATERMARK') && _vm.text)?_c('Watermark',{attrs:{"text":_vm.text}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }